import api from "./api";

export interface CCIRecord {
    _id: string;
    createdAt: string;
    vendor: {
        name: string;
        country: string;
    };
    consignee: {
        name: string;
        country: string;
    };
    dateOfDirectShipment: string;
    currency: string;
    totalValue: number;
    shipmentDetails: {
        transportation: string;
        countryOfTransshipment: string;
        conditionsOfSale: string;
        otherReferences: string;
        netWeight?: number;
        grossWeight?: number;
        weightUnit: string;
    };
}


export interface CCIRecordDetail extends CCIRecord {
    vendor: {
        name: string;
        address: string;
        city: string;
        stateProvince: string;
        postalCode: string;
        country: string;
    };
    consignee: {
        name: string;
        address: string;
        city: string;
        stateProvince: string;
        postalCode: string;
        country: string;
    };
    purchaser: {
        name: string;
        address: string;
        city: string;
        stateProvince: string;
        postalCode: string;
        country: string;
    };
    shipmentDetails: {
        transportation: string;
        countryOfTransshipment: string;
        conditionsOfSale: string;
        otherReferences: string;
        netWeight?: number;
        grossWeight?: number;
        weightUnit: string;
    };
    items: Array<{
        partNumber: string;
        description: string;
        hsCode: string;
        countryOfOrigin: string;
        quantity: number;
        unitPrice: number;
    }>;
}

export const cciHistoryService = {
    getHistory: async (): Promise<CCIRecord[]> => {
        const token = localStorage.getItem("token");
        const response = await api.get("/cci/history", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },

    getRecordById: async (id: string): Promise<CCIRecordDetail> => {
        const token = localStorage.getItem("token");
        const response = await api.get(`/cci/record/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    },

    downloadPDF: async (id: string): Promise<Blob> => {
        const token = localStorage.getItem("token");
        const response = await api.get(`/cci/download/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            responseType: 'blob',
        });
        return response.data;
    }
};
